import React from "react";

/**
 * Chief-complaints icons off the Figma boards (local Dev Mode asset server).
 * The toolbar plus / chev-up / field magnifier are the same DA component
 * instances the lab section already exported — reuse those from labIcons.
 */

/** 2961:3601 "md-cheveron-down" — the 11.3×6.7 vector centred in its 16 box. */
export const MdChevronDown = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M13.5 5.5L8 11L2.5 5.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Empty-state medallion — chat bubble with three dots. Stroke-only so it
    inherits the medallion's text colour and reads at any medallion size. */
export const ChatBubbleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 5.5C4 4.67 4.67 4 5.5 4h13c0.83 0 1.5 0.67 1.5 1.5v9c0 0.83-0.67 1.5-1.5 1.5H10l-4 3.5V16H5.5c-0.83 0-1.5-0.67-1.5-1.5v-9z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="8"  cy="10" r="1" fill="currentColor" />
    <circle cx="12" cy="10" r="1" fill="currentColor" />
    <circle cx="16" cy="10" r="1" fill="currentColor" />
  </svg>
);
